/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratUserInfo,
    JsonStratUserInfoFromJSON,
    JsonStratUserInfoFromJSONTyped,
    JsonStratUserInfoToJSON,
} from './JsonStratUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratUserInfo
 */
export interface ApiResultOfJsonStratUserInfo {
    /**
     * 
     * @type {JsonStratUserInfo}
     * @memberof ApiResultOfJsonStratUserInfo
     */
    data?: JsonStratUserInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratUserInfo
     */
    result?: ApiResultOfJsonStratUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratUserInfoFromJSON(json: any): ApiResultOfJsonStratUserInfo {
    return ApiResultOfJsonStratUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratUserInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratUserInfoToJSON(value?: ApiResultOfJsonStratUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratUserInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

